<template>
  <div class="point-link" :class="{ custom: havMargin }">
    <SvgIcon class="point-pink__icon" :width="iconSize" :height="iconSize" :icon="icon" />
    <!-- <div class="point-link__dash" v-show="!hiddenTail">
      <canvas id="point-link-canvas"></canvas>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'PointLink',
  props: {
    icon: {
      type: String,
      default: 'DO'
    },
    hiddenTail: {
      type: Boolean,
      default: false
    },
    lineDash: {
      type: Array,
      default: () => [20, 15]
    },
    iconSize: {
      type: String,
      default: '12'
    },
    havMargin: {
      type: Boolean,
      default: true
    },
    isHomePage: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    const element = this.$el.querySelector('#point-link-canvas')
    if (element) {
      const ctx = element.getContext('2d')
      const height = element.height

      ctx.lineWidth = 500
      ctx.beginPath()
      ctx.setLineDash(this.lineDash)
      ctx.moveTo(0, 0)
      ctx.lineTo(0, height)
      ctx.strokeStyle = '#BCBCBC'
      ctx.stroke()
    }
  }
}
</script>

<style lang="scss" scoped>
.point-link {
  position: absolute;
  top: 25px;
  height: 100%;
  left: -19px;

  // .point-link__dash {
  //   height: calc(100% - 17px);
  //   width: 2px;
  //   margin: 0 auto;
  //   margin-top: 12px;

  //   canvas {
  //     height: 100%;
  //     width: 100%;
  //   }
  // }
}

@media screen and (max-width: 480px) {
  .point-link {
    top: 3px !important;

    &.custom {
      margin: 0 12px;
    }
  }
}
</style>
